import { render, staticRenderFns } from "./canvas.vue?vue&type=template&id=f307619a&scoped=true&"
import script from "./canvas.vue?vue&type=script&lang=ts&"
export * from "./canvas.vue?vue&type=script&lang=ts&"
import style0 from "./canvas.vue?vue&type=style&index=0&id=f307619a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f307619a",
  null
  
)

export default component.exports